import { GenericUploadTranslations } from './generic-upload-translations.interface';

/**
 * Default English translations for Generic Upload Component
 */
export const DEFAULT_GENERIC_UPLOAD_TRANSLATIONS: GenericUploadTranslations = {
  buttons: {
    select: 'Select',
    retry: 'Retry',
    remove: 'Remove'
  },
  labels: {
    dropFilesHere: 'or Drop file here',
    allowedTypes: 'Allowed file types',
    maxSize: 'Maximum size',
    selectFiles: 'Select files',
    dropZone: 'File upload drop zone - click to select files or drag and drop',
    uploadedFiles: 'Uploaded files',
    uploadProgress: 'Upload progress'
  },
  states: {
    pending: 'Pending',
    uploading: 'Uploading',
    completed: 'Upload completed',
    failed: 'Upload failed'
  },
  errors: {
    fileTypeNotAllowed: 'File type {extension} is not allowed. Allowed types: {allowedTypes}',
    fileTooSmall: 'File size is too small. Minimum size: {minSize}',
    fileTooLarge: 'File size is too large. Maximum size: {maxSize}',
    uploadFailed: 'Upload failed'
  },
  units: {
    bytes: 'Bytes',
    kb: 'KB',
    mb: 'MB',
    gb: 'GB'
  }
};
